import { EnhancedStore } from '@reduxjs/toolkit';
import Axios, { AxiosResponse } from 'axios';

import {
    AUTH_ERROR_INVALID_TOKEN,
    DEFAULT_ERROR_MESSAGE,
    FAILURE_HEADER,
    MAIN_ROUTES
} from 'common/config';
import { HttpStatusCode, MessageType } from 'common/enums';
import { appStateActions } from 'common/redux/app-state';

let store: EnhancedStore;

export const injectStore = (_store: any) => {
    store = _store;
};

Axios.interceptors.response.use(
    (response: AxiosResponse) => {
        return response;
    },
    (error: any) => {
        if (error.response.status === HttpStatusCode.Unauthorized) {
            if (error.response.data === AUTH_ERROR_INVALID_TOKEN) {
                store.dispatch({
                    type: appStateActions.toggleSessionRenewal.type,
                    payload: true
                });
                store.dispatch({
                    type: appStateActions.showLoader.type,
                    payload: false
                });
            } else if (window.location.pathname !== MAIN_ROUTES.UNAUTHORIZED) {
                window.location.href = MAIN_ROUTES.UNAUTHORIZED;
            }
        } else if (
            error.response.status === HttpStatusCode.InternalServerError ||
            error.response.status === HttpStatusCode.NotFound
        ) {
            store.dispatch({
                type: appStateActions.showMessageModal.type,
                payload: {
                    isVisible: true,
                    header: FAILURE_HEADER,
                    message: DEFAULT_ERROR_MESSAGE,
                    type: MessageType.Error
                }
            });
            store.dispatch({
                type: appStateActions.showLoader.type,
                payload: false
            });
            return Promise.reject(error);
        } else {
            return Promise.reject(error);
        }
    }
);

Axios.interceptors.request.use((request: any) => {
    // if (xsrfToken) {
    //     request.headers['X-XSRF-TOKEN'] = xsrfToken;
    // }
    // request.headers['X-Requested-With'] = 'XMLHttpRequest';
    return request;
});

export default Axios;
